import collect from 'collect.js';

if (!window.rmes) window.rmes = {}

window.rmes.collect = collect